<template>
  <div>
  
    <div class="row">
      <div class="col-md-12">
      

            <p><strong style="font-size: 24px; color: #f1ba1b; display: block; padding-top: 1em;">Info</strong></p>
            <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
              <div class="text-center" v-if="isLoadingData ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

 <div class="row" v-if="OnlineReceipt.length > 0">
<table class="faq-table yellow" style="width: 88.987%; height: 320px;">
<tbody>
<tr style="height: 24px;">
<td style="width: 42.0057%; height: 24px;"><strong>Total Credit</strong></td>
<td style="width: 59.8068%; height: 24px;"><strong> {{OnlineReceipt[0].TotalCredit ? OnlineReceipt[0].TotalCredit : '' | toCurrency}} </strong></td>
</tr>
<tr style="height: 24px;">
<td style="width: 42.0057%; height: 24px;"><strong>Total UnPaid Debit</strong></td>
<td style="width: 59.8068%; height: 24px;"><strong>{{OnlineReceipt[0].TotalUnPaid ? OnlineReceipt[0].TotalUnPaid : ''  | toCurrency }}</strong></td>
</tr>
<tr style="height: 24px;">
<td style="width: 42.0057%;height: 24px;"><strong>Total Debit:</strong>


</td>
<td style="width: 59.8068%;height: 24px;"><strong>{{OnlineReceipt[0].TotalDebit ? OnlineReceipt[0].TotalDebit : '' | toCurrency }}</strong>


</td>
</tr>
<tr style="height: 24px;">
<td style="width: 42.0057%; height: 24px;"><strong>Available Credit</strong></td>
<td style="width: 59.8068%; height: 24px;"><strong>{{OnlineReceipt[0].AvailableCredit ? OnlineReceipt[0].AvailableCredit : '' | toCurrency}}</strong></td>
</tr>
<tr style="height: 24px;">
<td style="width: 42.0057%; height: 24px;"><strong>Current Balance</strong></td>

<td style="width: 59.8068%; height: 24px;" v-if="Math.sign(OnlineReceipt[0].TotalBalance)  < 0 "><strong class="text-danger">{{OnlineReceipt[0].TotalBalance ? OnlineReceipt[0].TotalBalance : '' | toCurrency}}</strong>
<td style="width: 59.8068%; height: 24px;" v-else><strong>{{OnlineReceipt[0].TotalBalance ? OnlineReceipt[0].TotalBalance : '' | toCurrency}}</strong>
</td>
</tr>

</tbody>
</table>
 </div>




            <!-- <div class="row" >
              <div class="col-md-10 col-sm-12">

  <div class="row" v-if="OnlineReceipt.length > 0">
              <div class="col-md-3 col-sm-12">
                <div class="profileData">Total Credit </div>
              </div>
              <div class="col-md-3 col-sm-12">
                  <div class="profileData2"> {{OnlineReceipt[0].TotalCredit ? OnlineReceipt[0].TotalCredit : ''}} </div>
                 
                 
              </div>
             <div class="col-md-3 col-sm-12">
                <div class="profileData">Total Debit:</div>
                 </div>
              <div class="col-md-3 col-sm-12">
                 <div class="profileData2">{{OnlineReceipt[0].TotalDebit ? OnlineReceipt[0].TotalDebit : '' }}</div>
                 </div>
             
             <div class="col-md-3 col-sm-12">
                <div class="profileData">Total UnPaid Debit </div>
                                  </div>
              <div class="col-md-3 col-sm-12">
                   <div class="profileData2">{{OnlineReceipt[0].TotalUnPaid ? OnlineReceipt[0].TotalUnPaid : ''}}</div>
                </div>
              
               <div class="col-md-3 col-sm-12">
                <div class="profileData">Available Credit </div>
                </div>
              
               <div class="col-md-3 col-sm-12">
                   <div class="profileData2">{{OnlineReceipt[0].AvailableCredit ? OnlineReceipt[0].AvailableCredit : ''}}</div>
                   </div>
            
                <div class="col-md-3 col-sm-12">
                <div class="profileData">Current Balance </div>
                </div>
                 <div class="col-md-3 col-sm-12">
               <div class="profileData2">{{OnlineReceipt[0].TotalBalance ? OnlineReceipt[0].TotalBalance : ''}}</div>
              </div>
            </div>


              </div>
              <div class="col-md-2 col-sm-12">
<div class="app-stu-photo">
              <img src="../../assets/SU_Logo.png" />
            </div>


              </div>
            </div> -->
          
            

            <div class="clearfix"></div>
        
      </div>
    </div>

   
    
  </div>
</template>
<script>
import studentData from '../../services/student/studentDataServices';
export default {
  
  name: "FinancialData",
  data() {
    return {
      selected: null,
      show: true,
      OnlineReceipt: '',
      isHidden: false,
      message: '',
      options: [
          { value: null, text: 'Select Method' },
          { value: 'a', text: 'Cash' },
          { value: 'b', text: 'Bank' },
          { value: 'c', text: 'Check' },
          { value: 'd', text: 'transfer' },

     ],
     isLoadingData : true
    };
  },
  computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },

       mounted(){
      
      //this.currenUser.StudentID  //4
            studentData.GetStudentBasicFinancialData(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.OnlineReceipt = Response.data
               this.isLoadingData = false
               // this.empty =false
                // eslint-disable-next-line no-console
                //  console.log(this.OnlineReceipt)
           },
         error => {
              
                  // eslint-disable-next-line no-console
                //  console.log(error.response.status)
                 this.isLoadingData = false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       
       
       },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;

  border-radius: 10px;
  border: 1px solid #111;
 
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}
.badge {
  padding: 0.65em 0.6em;
}

.profileData, .profileData2 {
    border: 1px dotted #646464;
    padding: 3px 10px;
    font-weight: 700;
    margin: 5px 0px;
}
.profileData {
    color: #285475;
}
.profileData2 {
    color: #ff8600;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

table {
    border-spacing: 1;
    border-collapse: collapse;
    background: white;
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    position: relative;
}

.faq-table {
    margin-bottom: 3em;
}

.faq-table.yellow tr {
    border: 1px solid #F1BA1B;
    border-left: transparent;
    border-right: transparent;
}
</style>
